import { useQuery } from '@tanstack/react-query';
import { publishQueryKeys } from './publishQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { getErrorStatus } from '../../errors/errors.utils.js';

const useQueryResourcePublishDetails = (resourceId) => {
  const { client } = useWoody();
  return useQuery({
    queryKey: publishQueryKeys.resourcePublishDetails(resourceId),
    queryFn: async () => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/publish",
        params: {
          resourceId
        }
      }).catch((e) => {
        if (getErrorStatus(e) === 404) {
          return null;
        }
        throw e;
      });
    },
    enabled: !!resourceId
  });
};

export { useQueryResourcePublishDetails };
//# sourceMappingURL=useQueryResourcePublishDetails.js.map
